import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { SnackbarAlert } from './components/snack/snackAlert';

// routes
import Router from './routes';

// theme
import ThemeProvider from './theme';

// store
import store from './server/store/store';

// style
import './style/custom.scss';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <Provider store={store}>
            <SnackbarAlert />
            <Router />
          </Provider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
